import React, { useRef } from 'react';
import { Spinner } from 'ui';
import ScrollableContainer from 'components/shared/scrollable';
import LoadableState from 'components/shared/loadable';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import { Calendar } from 'react-feather';
import { isEmpty } from 'lodash/fp';
import EventCard from './EventCard';

const EventList = ({
  events,
  setSelectedEvent,
  loading,
  previewing,
  getNextPage,
  page,
  totalPages,
  showLoadMore,
  emptyState,
}) => {
  const scrollableRef = useRef();

  const onScroll = () => {
    if (scrollableRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollableRef.current;
      const scrollPosition = scrollTop + clientHeight;
      /*
        scrollHeight can be miscalculated if user is zoomed in/out of browser
        since there is no reliable way across browsers to detect this, giving a margin of error of 2px
        should cover all potential edge cases
      */
      if (scrollHeight - scrollPosition <= 2) {
        if (page < totalPages) {
          getNextPage();
          setTimeout(() => {
            scrollableRef.current.scrollTo({
              top: scrollableRef.current.scrollHeight,
              behavior: 'smooth',
            });
          }, 0);
        }
      }
    }
  };

  return (
    <ScrollableContainer
      dark
      maxHeight={null}
      ref={scrollableRef}
      onScroll={onScroll}
    >
      <div className="EventList d-f p-8 fw-w">
        <LoadableState loading={loading} className="w-100p">
          {events.length > 0 &&
            events.map((event, i) => (
              <EventCard
                event={event}
                key={event.id}
                previewing={previewing}
                setSelectedEvent={setSelectedEvent}
              />
            ))}
          {showLoadMore && (
            <div className="d-f jc-c mt-24 mb-24">
              <Spinner />
            </div>
          )}
        </LoadableState>
      </div>
      {loading && isEmpty(events) && (
        <div className="EventList--empty d-f fd-c jc-c ai-c">
          <Spinner />
          <span className="ml-8 c-brand-gray-darker">Loading...</span>
        </div>
      )}
      {!events.length && !loading && (
        <div className="EventList--empty d-f fd-c jc-c ai-c">
          <Calendar size={50} />
          {emptyState === 'initial' ? (
            <>
              <Text variant={TEXT_VARIANTS.BODY} className="ta-c mt-8">
                {t('lessons.editor.event.empty_state_initial')}
              </Text>
              <Text variant={TEXT_VARIANTS.BODY_LIGHT} className="ta-c mt-4">
                {t('lessons.editor.event.empty_state_initial_desc')}
              </Text>
            </>
          ) : (
            <Text variant={TEXT_VARIANTS.BODY_LIGHT} className="ta-c mt-8">
              {t('lessons.editor.event.empty_state_search')}
            </Text>
          )}
        </div>
      )}
    </ScrollableContainer>
  );
};

export default EventList;
